export const CONST = {
    BACKEND_URL: 'https://www.urphysio.in/api/',
  
};